import type {FC, ReactNode} from 'react';

export interface TableActionsCellProps {
  children: ReactNode;
}

export const TableActionsCell: FC<TableActionsCellProps> = ({children}) => (
  <div
    role="presentation"
    className="flex items-center justify-end gap-3 ps-2"
    onClick={e => e.stopPropagation()}
    onKeyDown={e => e.stopPropagation()}
  >
    {children}
  </div>
);
